import { Label } from "@/components/ui/label";
import { ChoiceGrid, StepFooter, StepHeader, ValueSlider } from "./_widgets";

const YESNO = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

const ENERGY = [
  { value: "very_low", label: "Very Low" },
  { value: "low", label: "Low" },
  { value: "average", label: "Average" },
  { value: "high", label: "High" },
  { value: "very_high", label: "Very High" },
];

const MOOD = [
  { value: "poor", label: "Poor" },
  { value: "fair", label: "Fair" },
  { value: "good", label: "Good" },
  { value: "excellent", label: "Excellent" },
];

export default function Step6Recovery({ data, set, onNext }) {
  const sleep = data.sleep_hours ?? 7;
  const stress = data.stress_level ?? 5;
  const valid = !!data.shift_work && !!data.energy_level && !!data.mood;

  return (
    <div className="space-y-5">
      <StepHeader title="Recovery" subtitle="Recovery quality drives the entire plan." />

      <div className="space-y-1.5">
        <Label>Average sleep</Label>
        <ValueSlider
          value={sleep}
          onChange={(v) => set({ sleep_hours: v })}
          min={4}
          max={10}
          step={0.5}
          suffix=" hrs"
          testid="onb-sleep"
        />
      </div>

      <div className="space-y-1.5">
        <Label>Stress level</Label>
        <ValueSlider
          value={stress}
          onChange={(v) => set({ stress_level: v })}
          min={1}
          max={10}
          suffix=" / 10"
          testid="onb-stress"
        />
      </div>

      <div className="space-y-1.5">
        <Label>Do you work shifts or have an inconsistent schedule?</Label>
        <ChoiceGrid
          options={YESNO}
          value={data.shift_work}
          onChange={(v) => set({ shift_work: v })}
          columns={2}
          testid="onb-shift"
        />
      </div>

      <div className="space-y-1.5">
        <Label>How are your energy levels?</Label>
        <ChoiceGrid
          options={ENERGY}
          value={data.energy_level}
          onChange={(v) => set({ energy_level: v })}
          testid="onb-energy"
        />
      </div>

      <div className="space-y-1.5">
        <Label>How is your mood overall?</Label>
        <ChoiceGrid
          options={MOOD}
          value={data.mood}
          onChange={(v) => set({ mood: v })}
          columns={2}
          testid="onb-mood"
        />
      </div>

      <StepFooter valid={valid} onNext={onNext} />
    </div>
  );
}
